import type { Status, Severity } from '../../hooks/useAnomalies.js';

const ALL_SEVERITIES: Severity[] = ['critical', 'warning', 'info'];
const ALL_STATUSES: Status[] = ['open', 'acknowledged', 'ignored', 'all'];

export interface FilterState {
  from: string;
  to: string;
  storeId?: number;
  platforms: string[];
  severities: Severity[];
  status: Status;
}

interface Props {
  value: FilterState;
  onChange: (next: FilterState) => void;
}

export function AnomalyFilterBar({ value, onChange }: Props) {
  return (
    <div className="sticky top-0 z-10 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 p-3 flex flex-wrap gap-3 items-center">
      <label className="text-xs text-gray-500 flex items-center gap-1">
        From
        <input
          type="date"
          value={value.from}
          onChange={(e) => onChange({ ...value, from: e.target.value })}
          className="text-xs border rounded px-2 py-1"
        />
      </label>
      <label className="text-xs text-gray-500 flex items-center gap-1">
        To
        <input
          type="date"
          value={value.to}
          onChange={(e) => onChange({ ...value, to: e.target.value })}
          className="text-xs border rounded px-2 py-1"
        />
      </label>
      <label className="text-xs text-gray-500 flex items-center gap-1">
        Store ID
        <input
          type="number"
          placeholder="all"
          value={value.storeId ?? ''}
          onChange={(e) =>
            onChange({ ...value, storeId: e.target.value ? Number(e.target.value) : undefined })
          }
          className="text-xs border rounded px-2 py-1 w-24"
        />
      </label>
      <div className="flex gap-1">
        {ALL_SEVERITIES.map((s) => {
          const active = value.severities.includes(s);
          return (
            <button
              key={s}
              onClick={() => {
                const next = active
                  ? value.severities.filter((x) => x !== s)
                  : [...value.severities, s];
                onChange({ ...value, severities: next });
              }}
              className={`text-[10px] px-2 py-0.5 rounded border ${active ? severityColor(s) : 'border-gray-200 text-gray-500'}`}
            >
              {s}
            </button>
          );
        })}
      </div>
      <div className="flex gap-1">
        {ALL_STATUSES.map((s) => (
          <button
            key={s}
            onClick={() => onChange({ ...value, status: s })}
            className={`text-xs px-3 py-1 rounded ${value.status === s ? 'bg-gray-900 text-white dark:bg-gray-100 dark:text-gray-900' : 'text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800'}`}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}

function severityColor(s: Severity): string {
  if (s === 'critical') return 'border-red-300 text-red-700 bg-red-50';
  if (s === 'warning') return 'border-amber-300 text-amber-700 bg-amber-50';
  return 'border-blue-300 text-blue-700 bg-blue-50';
}
